"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerSubscriptions = void 0;
var _react = require("react");
var _SubscriptionPackage = require("./SubscriptionPackage");
var _SubscriptionUserHeader = require("./SubscriptionUserHeader");
var _jsxRuntime = require("react/jsx-runtime");
const CustomerSubscriptions = ({
  'data-testid': testId,
  isExpanded,
  placement,
  subscription,
  subscriptionItemInfo
}) => {
  const {
    customerId,
    customerName,
    packages
  } = subscription;
  const sortedPackages = [...packages].sort((a, b) => a.packageId - b.packageId || a.subscriptionId - b.subscriptionId || a.cycle - b.cycle || a.step - b.step);
  const [isOpened, setIsOpened] = (0, _react.useState)(isExpanded);
  const handleToggle = (0, _react.useCallback)(() => {
    setIsOpened(prevState => !prevState);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": `${testId}-customer-${customerId}`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionUserHeader.SubscriptionUserHeader, {
      customerName: customerName,
      handleToggle: handleToggle,
      isExpanded: isOpened,
      packageAmount: packages.length
    }), isOpened ? sortedPackages.map(packageItem => {
      const {
        cycle,
        packageId,
        step,
        subscriptionId
      } = packageItem;
      const key = `${step}-${subscriptionId}-${packageId}-${cycle}`;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionPackage.SubscriptionPackageComponent, {
        customerId: customerId,
        "data-testid": `${testId}-${key}`,
        isExpanded: isExpanded,
        placement: placement,
        subscriptionItemInfo: subscriptionItemInfo,
        ...packageItem
      }, key);
    }) : null]
  }, customerId);
};
exports.CustomerSubscriptions = CustomerSubscriptions;